import { emptyUserProfileApi } from "./emptyUserProfileApi.js";
import type { PatchProfileRequest, ProfileDocument } from "./types.js";

export const userProfileApi = emptyUserProfileApi.injectEndpoints({
	endpoints: (builder) => ({
		getProfile: builder.query<ProfileDocument, void>({
			query: () => "/v1/me/profile",
			providesTags: ["UserProfile"],
		}),

		patchProfile: builder.mutation<ProfileDocument, PatchProfileRequest>({
			query: (body) => ({
				url: "/v1/me/profile",
				method: "PATCH",
				body,
			}),
			invalidatesTags: ["UserProfile"],
		}),
	}),
});

export const { useGetProfileQuery, usePatchProfileMutation } = userProfileApi;
